module.exports = __webpack_public_path__ + "static/service-banner-a7add1bd2fea7fc67513df6721b1f6f0.jpg";